import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { SchoolService } from "../../../../../shared/services/school.service";
import { SysAdminService } from "../../../services/sysadmin.service";
import { ChangeIntsModel } from "../../ChangeIntsModel";

@Component({
	selector: "app-mscadd-school",
	templateUrl: "./mscadd-school.component.html",
	styleUrls: ["./mscadd-school.component.css"],
})
export class MSCAddSchoolComponent implements OnInit {
	constructor(
		private ref: DynamicDialogRef,
		private dialogConfig: DynamicDialogConfig,
		private sysAdminService: SysAdminService,
		private confirmationService: ConfirmationService,
		private schoolService: SchoolService
	) {}

	ngOnInit(): void {
		//Get data from parent
		this.SchoolGroupID = this.dialogConfig.data.SchoolGroupID;

		this.UpdateSelected();

		//Get Data from DB
		this.loadSchoolList();
	}

	///////////////////////////////////////////////////////
	// Data
	///////////////////////////////////////////////////////

	//Data from Parent
	SchoolGroupID: any;

	//Table Data
	lstSchools: any = [];
	SelectedSchools: any = [];
	OriginalSchools: any = [];

	pagerows: any = 5;
	pagefirst: any = 0;

	cols = [
		{ field: "SchoolNumber", header: "School Number" },
		{ field: "SchoolName", header: "School Name" },
	];

	loading: any = false;

	///////////////////////////////////////////////////////

	///////////////////////////////////////////////////////
	// Load Data
	///////////////////////////////////////////////////////
	private loadSchoolList() {
		this.loading = true;

		var result = this.schoolService.loadSchoolList("");
		result.subscribe(
			(response) => {
				this.lstSchools = response;
				this.SelectedSchools = [];

				this.SelectedSchools = this.dialogConfig.data.SelectedSchools;

				this.loading = false;
			},
			(error) => {}
		);
	}

	UpdateSelected() {
		this.SelectedSchools = this.dialogConfig.data.SelectedSchools;
		this.OriginalSchools = this.dialogConfig.data.SelectedSchools;
	}
	///////////////////////////////////////////////////////

	///////////////////////////////////////////////////////
	// Buttons
	///////////////////////////////////////////////////////
	onSelectAll() {}
	onUnselectAll() {}
	onUpdate() {
		//Get rid of containers that are already attached to the User Group
		var SchoolsToAdd = this.SelectedSchools.filter((cont) => this.OriginalSchools.indexOf(cont) == -1);

		//Create list of strings
		var lstSchoolID: number[] = [];

		for (var i = 0; i < SchoolsToAdd.length; i++) {
			var next = Number(SchoolsToAdd[i].SchoolID);
			lstSchoolID = [...lstSchoolID, next];
		}

		//Create Query Data
		let data: ChangeIntsModel = {
			MainID: this.SchoolGroupID,
			IDList: lstSchoolID,
		};

		//Call SP
		var result = this.sysAdminService.SchoolGroupAddSchools(data);
		result.subscribe(
			(response) => {
				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Schools were added successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could not add schools to the School Container",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	onClose() {
		this.ref.close(0);
	}
	///////////////////////////////////////////////////////

	///////////////////////////////////////////////////////
	// Events
	///////////////////////////////////////////////////////
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {}
	onRowUnselect(val) {}
	///////////////////////////////////////////////////////
}
